import { useEffect, useState } from 'react'
import activityApi from '@/apis/activity'
import {
  MatchingPresentation,
  resolveMatchingPresentation,
} from '@/pages/application-flow-skins/theme/matching-presentation'

interface ChannelDetail {

  /** 渠道模板是等待页 v1/v2 与主题的唯一选择依据。 */
  channelTemplate?: unknown
}

/**
 * useMatchingPresentation — 加载资料提交与重匹配等待页共用的渠道展示配置。
 * Hook 只提供 v1/v2 展示选择，不读取或改变提交、Storage、埋点、定时器及后续分流状态。
 * @param {string} adChannelCode 旧容器已解析的渠道码
 * @returns {MatchingPresentation | null | undefined} 加载中的 undefined、有效的 v2 配置或回退旧 UI 的 null
 */
const useMatchingPresentation = (
  adChannelCode: string,
): MatchingPresentation | null | undefined => {
  // 无渠道码时可立即确认走旧页，避免先渲染加载态再切换一次；有渠道码才等待展示配置返回。
  const [presentation, setPresentation] = useState<MatchingPresentation | null | undefined>(() => (
    adChannelCode ? undefined : null
  ))

  useEffect(() => {
    if (!adChannelCode) {
      setPresentation(null)
      return undefined
    }

    let active = true
    const getChannelDetail = async() => {
      try {
        const detail = await activityApi.getChannelCodeDetail(adChannelCode) as ChannelDetail
        if (active) {
          setPresentation(resolveMatchingPresentation(detail))
        }
      } catch (error) {
        // 配置不可用时必须保持旧 UI，不能干扰已经开始的提交与计时链路。
        if (active) {
          setPresentation(null)
        }
      }
    }

    getChannelDetail()
    return () => {
      active = false
    }
  }, [adChannelCode])

  return presentation
}

export default useMatchingPresentation
